import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { initSentry, Sentry } from './sentry';
import { attachSentryInterceptor } from './Service/sentryInterceptor';
import ErrorFallback from './Components/ErrorFallback/ErrorFallback';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import TokenService from './Service/TokenService';
import PushNotificationService from './Service/PushNotificationService';

// Before anything renders. No-op without REACT_APP_SENTRY_DSN.
initSentry();
// The shared `api` instance gets its interceptor in Service/api.js; this one
// covers the remaining raw-axios calls (PublicBookingService, ReservationConfirmService).
attachSentryInterceptor(axios);

window.addEventListener('appinstalled', () => {
    const userId = TokenService.getUserId();
    if (userId) {
        PushNotificationService.reportPwaInstalled(userId);
    } else {
        localStorage.setItem('pwa_install_pending', '1');
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Sentry.ErrorBoundary>
  // </React.StrictMode>
);

serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        window.dispatchEvent(new CustomEvent('sw-update-available', { detail: registration }));
    },
});

reportWebVitals();
